import { Link } from "react-router-dom";
import "./button.scss";

export default function Button({
    path,
    variant,
    type,
    icon,
    label,
    onClick,
    fullWidth,
    iconOnly,
    size = "M",
    statusType = "default",
    state = "default",
}) {
    const buttonClass = `btn ${variant === "filled" ? "filled" : "outline"} ${
        fullWidth ? "width-100" : "width-fit"
    } ${
        iconOnly ? "icon-only" : ""
    } size-${size} status-${statusType} state-${state}`;

    const isDisabled = state === "disabled" || state === "loading";

    if (path) {
        return (
            <Link to={path} className={buttonClass} aria-disabled={isDisabled}>
                {icon && <span className="btn__icon">{icon}</span>}
                {!iconOnly && <span className="btn__label">{label}</span>}
            </Link>
        );
    } else {
        return (
            <button
                className={buttonClass}
                onClick={onClick}
                type={type}
                disabled={isDisabled}
            >
                {icon && <span className="btn__icon">{icon}</span>}
                {!iconOnly && (
                    <span className="btn__label">
                        {state === "loading" ? "Loading..." : label}
                    </span>
                )}
            </button>
        );
    }    
}
